import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '@services/user.service';
import { WebErrorService } from '@services/webError.service';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'credits-usage',
  templateUrl: './credits-usage.component.html',
  styleUrls: ['./credits-usage.component.scss']
})
export class CreditsUsageComponent implements OnInit, OnDestroy {
  credits: any;
  startDate: any;
  endDate: any;
  public noDataFound: boolean = false;
  public lastDays: string = "30";
  public last90: boolean = false;
  displayedColumns: string[] = ['collectionname', 'Testname', 'schedulename', 'schedulestart&enddate', 'schedulelastupdatedby', 'creditsused'];
  constructor(private userService: UserService, public datepipe: DatePipe, private webErrorService: WebErrorService, private translate: TranslateService) { }
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) set content(paginator: MatPaginator) { }
  @ViewChild(MatPaginator) paginator: MatPaginator;
  private unsubscribe: Subject<void> = new Subject<void>();
  showPaginator = false;

  ngOnInit(): void {
    this.last30Days();
  }

  last30Days() {
    this.lastDays = "30";
    this.endDate = new Date();
    this.startDate = new Date(new Date().setDate(this.endDate.getDate() - 30));
    this.getAllData();
  }

  last90Days() {
    this.lastDays = "90";
    this.endDate = new Date();
    this.startDate = new Date(new Date().setDate(this.endDate.getDate() - 90));
    this.getAllData();
  }

  getAllData(data?: string) {
    this.noDataFound = false;
    if (!!data && data === "search") { this.lastDays = "" }
    const StartDate = this.datepipe.transform(this.startDate, 'dd-MM-yyyy');
    const EndDate = this.datepipe.transform(this.endDate, 'dd-MM-yyyy');
    if (StartDate && EndDate) {
      const newLocal: Subscription = this.userService.getCredits(StartDate, EndDate).subscribe(resp => {
        this.credits = new MatTableDataSource(resp.creditUsages);
        this.credits.sort = this.sort;
        this.credits.paginator = this.paginator;
        this.setPaginatorTranslation(this.credits);
        if (resp.creditUsages == 0) this.noDataFound = true;
      }, (error: any) => { this.webErrorService.handleAPIErrors(error); }, () => { newLocal.unsubscribe() });
    }
  }


  setPaginatorTranslation(data: any) {
      if(data.data.length > 0) {
        this.showPaginator = true;
        this.translate.stream([
          'subscription.TabCreditUsage.pagination.pageLabel',
          'subscription.TabCreditUsage.pagination.firstPage',
          'subscription.TabCreditUsage.pagination.lastPage',
          'subscription.TabCreditUsage.pagination.nextPage',
          'subscription.TabCreditUsage.pagination.prevPage'
        ]).pipe(takeUntil(this.unsubscribe)).subscribe(translation => {
            data.paginator._intl.itemsPerPageLabel = translation['subscription.TabCreditUsage.pagination.pageLabel'];
            data.paginator._intl.firstPageLabel = translation['subscription.TabCreditUsage.pagination.firstPage'];
            data.paginator._intl.lastPageLabel = translation['subscription.TabCreditUsage.pagination.lastPage'];
            data.paginator._intl.nextPageLabel = translation['subscription.TabCreditUsage.pagination.nextPage'];
            data.paginator._intl.previousPageLabel = translation['subscription.TabCreditUsage.pagination.prevPage'];

            data.paginator._intl.changes.next();
        });
      } else {
        this.showPaginator = false;
      }
  }


  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

}
